import Home from "./Pages/Home";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import ScrollToTop from './Components/ScrollToTop';
import TagManager from 'react-gtm-module';
import { useEffect } from "react";
import * as ChannelService from '@channel.io/channel-web-sdk-loader';

import Login from "./Pages/Login";
import SignUp from "./Pages/SignUp";
import Pricing from "./Pages/Pricing";

import SignupEmail from "./Pages/SignupEmail";
import VerifyEmail from "./Pages/VerifyEmail";
import ResetPassword from "./Pages/PasswordReset";
import WorkSpaceIvite from "./Pages/WorkSpaceIvite";
import ProjectInvite from "./Pages/ProjectInvite";
import SuccessPage from "./Pages/SuccessPage";


import FailPage from "./Pages/FailPage";
import { PublicRoute } from "./Components/PublicRoute";
import { GoogleOAuthProvider } from '@react-oauth/google';
import ContactForm from "./Pages/ContactForm";
import TermsOfService from './Pages/TermOfService';
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import SecretFreeTrial from "./Pages/SecretFreeTrial";
import ToolsOverview from "./Pages/Tool/ToolsOverview";
import SignificanceCalculator from "./Pages/Tool/SignificanceCalculator";
import DurationCalculator from "./Pages/Tool/DurationCalculator";
import EffectCalculator from "./Pages/Tool/EffectCalculator";
import ROICalculator from "./Pages/Tool/ROICalculator";
import FreeStart from "./Pages/FreeStart";
import AbtestEbookLandingPage from "./Pages/AbtestEbook/AbtestEbookLandingPage";
import FreeStartLanding from "./Pages/FreeStartLanding/FreeStartLanding";
import Cafe24Entry from "./Pages/Cafe24/Cafe24Entry";
import CaseStudiesLanding from "./Pages/CaseStudy/CaseStudiesLanding";
import ServiceAbtest from "./Pages/ServiceFeatures/ServiceAbtest";
import ServiceHeatmap from "./Pages/ServiceFeatures/ServiceHeatmap";
import ServicePopup from "./Pages/ServiceFeatures/ServicePopup";
import MarketingUnsubscribe from "./Pages/UserUnsubscribe/MarketingUnsubscribe";
import UserUnsubscribe from "./Pages/UserUnsubscribe/UserUnsubscribe";
import ImwebEntry from "./Pages/ImwebEntry";
import ServiceFunnel from "./Pages/ServiceFeatures/ServiceFunnel";
import Cafe24Onboarding from "./Pages/Cafe24/Cafe24Onboarding";
import ServiceReplay from "./Pages/ServiceFeatures/ServiceReplay";
import ServicePersonalization from "./Pages/ServiceFeatures/Servicepersonalization";


function App() {
  // 앱 시작 시 GTM 초기화
  useEffect(() => {
    TagManager.initialize({ gtmId: 'GTM-WWZRNZ9S' });
  }, []);

  // 2. 채널톡 초기화 (익명 모드)
  useEffect(() => {
    ChannelService.loadScript();
    ChannelService.boot({
      "pluginKey": "cb627fe5-2cda-4e07-80a4-e63572c0c54a"
    });

    ChannelService.onChatCreated(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'channeltalk_chat_created' });
  });

    return () => {
      ChannelService.clearCallbacks();
      ChannelService.shutdown();
    };
  }, []);

  return (
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
      onScriptLoadError={() => console.log('Load Error')}
      onScriptLoadSuccess={() => console.log('Load Success')}
    >
      <div>
        <BrowserRouter>
          <ScrollToTop /> {/*페이지 이동 간 스크롤 초기화 */}
          <Routes>
            {/* 로그인 없이 접근 가능한 라우트들 */}
            {/* 로그인한 사용자가 접근 불가능한 라우트들 */}
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/signup" element={<PublicRoute><SignUp /></PublicRoute>} />
            <Route path="/signupemail" element={<PublicRoute><SignupEmail /></PublicRoute>} />
            <Route path="/verify-email" element={<PublicRoute><VerifyEmail /></PublicRoute>} />
            <Route path="/password-reset/" element={<PublicRoute><ResetPassword /></PublicRoute>} />

            {/* 누구나 접근 가능한 라우트들 */}
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/fail" element={<FailPage />} />
            <Route path="/contact" element={<ContactForm />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/workspace-invite/:workspace_code" element={<WorkSpaceIvite />} />
            <Route path="/project-invite/:project_code" element={<ProjectInvite />} />
            <Route path="/service/ab-test" element={<ServiceAbtest />} />
            <Route path="/service/heatmap" element={<ServiceHeatmap />} />
            <Route path="/service/funnel" element={<ServiceFunnel />} />
            <Route path="/service/popup" element={<ServicePopup />} />
            <Route path="/service/replay" element={<ServiceReplay />} />
            <Route path="/service/personalization" element={<ServicePersonalization />} />
            <Route path="/secretfreetrial" element={<SecretFreeTrial />} />
            <Route path="/cafe24/entry" element={<Cafe24Entry />} />
            <Route path="/onboarding/cafe24" element={<Cafe24Onboarding />} />
            <Route path="/imweb/entry" element={<ImwebEntry />} />

            <Route path="/tools" element={<ToolsOverview />} />
            <Route path="/tools/significance" element={<SignificanceCalculator />} />
            <Route path="/tools/duration" element={<DurationCalculator />} />
            <Route path="/tools/effect" element={<EffectCalculator />} />
            <Route path="/tools/roi" element={<ROICalculator />} />
            <Route path="/freestart" element={<FreeStart />} />
            <Route path="/freestartlanding" element={<FreeStartLanding />} />
            <Route path="/casestudy" element={<CaseStudiesLanding />} />

            <Route path="/unsubscribe" element={<MarketingUnsubscribe />} />
            <Route path="/unsubscribe/user" element={<UserUnsubscribe />} />

            <Route path="/abtestebook" element={<AbtestEbookLandingPage />} />

            {/* 로그인 필요한 라우트들 */}
          </Routes>
        </BrowserRouter>
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;